import React, { Suspense, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { UseRegisterSlides } from '@components/onboarding-guide/hooks/UseRegisterSlides';
import {
  BASE_RETAIL_PATH,
  COLLECTION_PATH,
  getBaseRetailPathDefinition,
  getNewronLogoutPath,
  getRetailPathDefinition,
  isAllowedRetailPath,
  NOTIFICATIONS_PREFERENCES,
  OLD_BASE_RETAIL_PATH,
  RETAIL_ALLOWED_PATH,
} from '@utils/UrlUtils';
import { deleteLocalStorageByKey, deleteSessionStorage, StorageKey } from '@utils/StorageUtils';
import PagesConfigProvider from '@utils/pageConfig/PagesConfigProvider';
import { feedback } from '@ecosystem/newron-design-system';
import App from './App';

const { DotsLoader } = feedback;

export const RootContainer: React.FC = () => {
  const [showRetail, setShowRetail] = useState(true);
  const location = useLocation();
  UseRegisterSlides();

  useEffect(() => {
    const p = window.location.pathname;
    const isCollectionOrNotification = p.startsWith(COLLECTION_PATH) || p.startsWith(NOTIFICATIONS_PREFERENCES);
    setShowRetail(isAllowedRetailPath(p) && !isCollectionOrNotification);
    if (p.includes(OLD_BASE_RETAIL_PATH)) window.location.href = p.replace(OLD_BASE_RETAIL_PATH, BASE_RETAIL_PATH);
    if (p === getNewronLogoutPath()) {
      deleteLocalStorageByKey(StorageKey.UserData);
      deleteSessionStorage();
    }
  }, [location]);

  if (!showRetail) {
    return (
      <PagesConfigProvider>
        <Suspense fallback={<DotsLoader />}>
          <App />
        </Suspense>
      </PagesConfigProvider>
    );
  }

  return (
    <PagesConfigProvider>
      <RootSwitch />
    </PagesConfigProvider>
  );
};

const RootSwitch: React.FC = () => {
  const p = window.location.pathname;
  const basePath = getRetailPathDefinition(BASE_RETAIL_PATH);
  const isAtBase = p === basePath || p === `${basePath}${getBaseRetailPathDefinition()}`;

  if (isAtBase) {
    return <Navigate to={getRetailPathDefinition(RETAIL_ALLOWED_PATH.RETAILER_OVERVIEW)} replace />;
  }

  return (
    <Routes>
      <Route
        path="*"
        element={
          <Suspense fallback={<DotsLoader />}>
            <App />
          </Suspense>
        }
      />
    </Routes>
  );
};
